import React, { useContext } from "react"
import { createPortal } from "react-dom"

import Toast from "."
import { ToastContext } from "./ToastContext"

const ToastContainer = () => {
  const { toasts } = useContext(ToastContext)

  if (toasts.length === 0) {
    return null
  }
  if (typeof document === "undefined") return null

  // Portal to document.body so toasts escape any ancestor `isolation: isolate`
  // stacking context and stay above modals (which Base UI also portals to body).
  return createPortal(
    <div className="fixed inset-x-0 bottom-0 z-toast flex flex-col-reverse items-center justify-center p-4">
      {toasts.map((toast) => {
        return (
          <div className="my-2 max-w-max break-words" key={`toast-${toast.id}`}>
            <Toast duration={toast.duration} type={toast.type}>
              {toast.message}
            </Toast>
          </div>
        )
      })}
    </div>,
    document.body
  )
}

export default ToastContainer
